const $$splitComponentImporter = () => import('/app/src/routes/dashboard/therapist/group-therapies.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/therapist/group-therapies")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});